export default __webpack_public_path__ + "pdfjs-dist-ie11-ledge/pdf.min-bedea0f7caa6c775e87330a3f998009e.js";